import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeleteModalService {

  // Observable  source
  private deletionSource = new Subject<any>();
  private confirmDeletionSource = new Subject<any>();
  // Observable stream
  deletion = this.deletionSource.asObservable();
  confirmDeletion = this.confirmDeletionSource.asObservable();
  // service command
  deleteEvent(item: any) {
    this.deletionSource.next(item);
  }
  confirmDeleteEvent(item: any) {
    this.confirmDeletionSource.next(item);
  }
}
